import { Button, Dialog, Intent, Shape } from '@axieinfinity/matcha'
import {
  ShieldWarningFillIcon,
  WalletFillIcon,
} from '@axieinfinity/matcha-icons'

import { useAuthContext } from '~/hooks/useAuthContext'
import imgRonin from '~/public/images/ronin-blue.png'

type TWalletWrongAddressModalProps = {
  visible: boolean
  onClose: () => void
}

const WalletWrongAddressModal: React.FC<TWalletWrongAddressModalProps> = ({
  visible,
  onClose,
}) => {
  const { userV2 } = useAuthContext()
  const roninAddress = userV2?.account?.wallet?.secondary || ''
  const displayAddress = `${roninAddress.slice(0, 12)}...${roninAddress.slice(
    -5,
  )}`

  return (
    <Dialog
      className="[&_.dango-dialog-content]:bg-surface-color-default [&_.dango-dialog-content]:border [&_.dango-dialog-content]:border-border-color-default [&_.dango-dialog-body]:p-0 [&_.dango-dialog-content]:!p-0 p-16 !w-[390px] sm:!w-[480px]"
      visible={visible}
      onClose={onClose}
      destroyOnClose
      size="small"
    >
      <div className="flex flex-col items-center text-center p-24">
        <div className="relative mt-20 mb-24">
          <img width={105} height={105} src={imgRonin} alt="warning" />
          <div className="absolute" style={{ right: 0, bottom: -12 }}>
            <ShieldWarningFillIcon size={32} />
          </div>
        </div>

        <div className="text-large leading-28 mb-4 font-semibold">
          Wrong Ronin Wallet
        </div>
        <div className="text-normal leading-20 text-text-color-subdued mb-12 font-medium">
          <p className="mb-0">
            Your current account and Ronin wallet address don’t match.
          </p>
          <p className="mb-0">
            Please go to your Ronin wallet and switch the address to:
          </p>
        </div>
        {displayAddress && (
          <div className="rounded-2x bg-light-2 mb-24 flex h-20 cursor-default items-center justify-center px-8">
            <WalletFillIcon size={16} />
            <p className="text-x-small leading-16 mb-0 ml-4 font-medium ">
              {displayAddress}
            </p>
          </div>
        )}

        <Button
          onClick={onClose}
          shape={Shape.Default}
          intent={Intent.Primary}
          text="Got it"
        />
      </div>
    </Dialog>
  )
}

export default WalletWrongAddressModal
